import React from "react";

function Cart() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11.2619 8.95815C11.8122 8.95815 12.2966 8.65729 12.5461 8.20233L15.1731 3.4399C15.4446 2.95558 15.0924 2.35386 14.5347 2.35386H3.67431L2.98452 0.88623H0.584961V2.35386H2.05258L4.6943 7.92348L3.70366 9.71398C3.16798 10.6973 3.87243 11.8934 4.98783 11.8934H13.7935V10.4258H4.98783L5.79502 8.95815H11.2619ZM4.37143 3.82148H13.2872L11.2619 7.49053H6.11056L4.37143 3.82148ZM4.98783 12.6272C4.18063 12.6272 3.52754 13.2877 3.52754 14.0948C3.52754 14.902 4.18063 15.5625 4.98783 15.5625C5.79502 15.5625 6.45545 14.902 6.45545 14.0948C6.45545 13.2877 5.79502 12.6272 4.98783 12.6272ZM12.3259 12.6272C11.5187 12.6272 10.8656 13.2877 10.8656 14.0948C10.8656 14.902 11.5187 15.5625 12.3259 15.5625C13.1331 15.5625 13.7935 14.902 13.7935 14.0948C13.7935 13.2877 13.1331 12.6272 12.3259 12.6272Z"
        fill="url(#svg-grad)"
      />
      <defs>
        <linearGradient
          id="svg-grad"
          x1="0.584961"
          y1="15.5625"
          x2="15.885"
          y2="1.56197"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0854" class="start-color" />
          <stop offset="0.922" class="end-color" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Cart;
